export default [
  // transactions router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Paiements",
      layout: "dashboard",
    },
    path: "/transactions",
    name: "transactions",
    component: () => import("@/layouts/index/TransactionIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste des paiements des clients",
          layout: "dashboard",
        },
        path: "customers/index",
        name: "transactions-index",
        component: () => import("@/views/transactions/Listing.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un nouveau paiement pour le client",
          layout: "dashboard",
        },
        path: "customers/create",
        name: "transactions-create",
        component: () => import("@/views/transactions/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier le paiment",
          layout: "dashboard",
        },
        path: "customers/:reference/edit",
        name: "transactions-edit",
        component: () => import("@/views/transactions/Edit.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails d'un paiement",
          layout: "dashboard",
        },
        path: "customers/:reference/details",
        name: "transactions-details",
        component: () => import("@/views/transactions/Details.vue"),
      },
    ],
  },
];
